module.exports = __webpack_public_path__ + "static/media/instagram.23c1ab40.svg";